import { CannedQuestionName } from '../../../api/models/survey';
import { BUYER_ID } from '../../../models/survey';
import { CheckoutState } from '../../../state';
import { getInteractiveQuestionsByAttendeeId } from '../pureSelectors';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getHasQuebecQSTTaxQuestion = (state: CheckoutState): boolean => {
    const interactiveQuestionsByAttendeeId =
        getInteractiveQuestionsByAttendeeId(state);

    return !!interactiveQuestionsByAttendeeId[BUYER_ID]?.find(
        ({ questionId }) => questionId === CannedQuestionName.qstZipCode,
    );
};
